export const failureLottieAnimation = {
  options: {
    path: 'assets/animations/failure.json',
    loop: false
  },
  height: '100%',
  width: '100%'
};
